import React from 'react';
import StudentManagementPanel from './StudentManagementPanel';

/**
 * AdminStudents — entry point for /admin/students
 * Renders the full-featured StudentManagementPanel inside AdminLayout.
 */
const AdminStudents = () => <StudentManagementPanel />;

export default AdminStudents;
